import React from 'react';
import './AccountPages.scss';

/** Web account pages: breadcrumbs + centered content (no orders-style filter sidebar). */
export function AccountWebLayout({ title, children }) {
    // Same trail + markup as Wishlist web
    const breadcrumbs = [
        { label: 'Home', href: '/' },
        { label: 'My Account', href: '/account' },
        { label: title, href: null, isActive: true },
    ];

    return (
        <div className="account-web-page">
            <div className="breadcrumbs-wrapper">
                <div className="breadcrumbs-container breadcrumbs-design-6">
                    {breadcrumbs.map((crumb, index) => (
                        <React.Fragment key={index}>
                            {index > 0 && <span className="breadcrumbs-separator">/</span>}
                            {crumb.isActive ? (
                                <span className="breadcrumbs-current">{crumb.label}</span>
                            ) : (
                                <a href={crumb.href} className="breadcrumbs-link">
                                    {crumb.label}
                                </a>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
            <div className="account-web-container">{children}</div>
        </div>
    );
}

export function AccountPageHeader({ title, description, action }) {
    return (
        <header className="account-web-header">
            <div className="account-web-header__text">
                <h1>{title}</h1>
                {description ? <p>{description}</p> : null}
            </div>
            {action ? <div className="account-web-header__action">{action}</div> : null}
        </header>
    );
}

export function AccountTabBar({ tabs, activeId, onChange, ariaLabel }) {
    return (
        <div className="account-web-tabs" role="tablist" aria-label={ariaLabel}>
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    aria-selected={activeId === tab.id}
                    className={`account-web-tabs__tab${
                        activeId === tab.id ? ' account-web-tabs__tab--active' : ''
                    }`}
                    onClick={() => onChange(tab.id)}
                >
                    {tab.label}
                    {tab.count != null && (
                        <span className="account-web-tabs__count">{tab.count}</span>
                    )}
                </button>
            ))}
        </div>
    );
}

export function AccountStatStrip({ items }) {
    return (
        <div className="account-web-stats">
            {items.map((item) => (
                <div key={item.label} className="account-web-stats__item">
                    <span className="account-web-stats__label">{item.label}</span>
                    <span
                        className={`account-web-stats__value${
                            item.tone ? ` account-web-stats__value--${item.tone}` : ''
                        }`}
                    >
                        {item.value}
                    </span>
                </div>
            ))}
        </div>
    );
}
